import script from "./RoomAvailabilityHeaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomAvailabilityHeaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./RoomAvailabilityHeaderComponent.vue?vue&type=style&index=0&id=8b0caed6&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b0caed6"]])

export default __exports__